import TableAnimeDetails from "./tableAnimeDetails";

export default TableAnimeDetails